import { render } from "./Affiliates.vue?vue&type=template&id=2173fc5d&scoped=true"
import script from "./Affiliates.vue?vue&type=script&lang=js"
export * from "./Affiliates.vue?vue&type=script&lang=js"

import "./Affiliates.vue?vue&type=style&index=0&id=2173fc5d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2173fc5d"]])

export default __exports__